import { DefaultRoute } from '../router/routes'

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')


export const getBaseUrl = () => {
  if (window.location && window.location.hostname && window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    // Code to run in the local environment
    return 'https://localhost:8080/';
  } else {
    // Code to run in the production environment
    return 'https://server.insightai.in/';
  }
}

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('token')
export const getUserData = () => localStorage.getItem('token')
export const getUserRole = () => localStorage.getItem('role')


/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  return DefaultRoute
  // if (userRole === 'admin') return DefaultRoute
  // if (userRole === 'client') return '/access-control'
  // return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})

export const storeLastUrl = (url) => {
  localStorage.setItem('dashboard_link', url);
};

export const redirectToLastUrl = () => {
  const lastUrl = localStorage.getItem('dashboard_link');
  if (lastUrl) {
    window.location.href = lastUrl;
  }
};

export const toCamelCase = (input) => {
  if (typeof input !== 'string') {
    return String(input); // Convert non-string inputs to string
  }

  // Normalize the input by replacing underscores and hyphens with spaces
  const normalizedString = input
    .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
    .replace(/([a-z])([A-Z])/g, '$1 $2'); // Add a space before capital letters

  // Format the string: capitalize words and handle numbers
  const formattedString = normalizedString
    .split(' ') // Split the string into words
    .map(word =>
      isNaN(word) // Check if the word is not a number
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize if it's not a number
        : word // Leave numbers as is
    )
    .join(' '); // Join the words with a space

  return formattedString.length > 15
    ? formattedString.slice(0, 15) + '...'
    : formattedString;
}

export const convertRupeesToPaise = (rupees)=>{
  return rupees * 100;
}

export const getDomainName = (url) => {
  try {
      const hostname = new URL(url).hostname;
      const parts = hostname.split('.');
      const domain = parts.slice(-2, -1)[0];
      return domain.charAt(0).toUpperCase() + domain.slice(1);
  } catch (error) {
      console.error("Invalid URL:", error);
      return null;
  }
}

export const getDaysRemaining = (dueDate) => {
  if (!dueDate) return '-';

  const today = new Date();
  const due = new Date(dueDate);

  // Normalize time to midnight for accurate diff
  today.setHours(0, 0, 0, 0);
  due.setHours(0, 0, 0, 0);

  const diffTime = due - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return `Overdue by ${Math.abs(diffDays)} day${Math.abs(diffDays) > 1 ? 's' : ''}`;
  if (diffDays === 0) return 'Due today';
  return `Due in ${diffDays} day${diffDays > 1 ? 's' : ''}`;
};

